import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class CommonFunction {
  static getBase64 = (file: File): Promise<string | ArrayBuffer | null> =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });

  static getDay(date: string) {
    if (date) {
      const publishDate = new Date(date);
      return publishDate.getDate();
    } else {
      const publishDate = new Date();
      return publishDate.getDate();
    }
  }

  static getMonth(date: string) {
    const lang = localStorage.getItem('LANGUAGE');

    const publishDate = date ? new Date(date) : new Date();

    return new Intl.DateTimeFormat(lang === 'vi' ? 'vi-VN' : 'en-US', {
      month: 'long',
    }).format(publishDate);
  }

  static getYear(date: string) {
    if (date) {
      const publishDate = new Date(date);
      return publishDate.getFullYear();
    } else {
      const publishDate = new Date();
      return publishDate.getFullYear();
    }
  }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function jwtOptionsFactory(options: any) {
  const whitelist = options.config?.allowedDomains || [];

  function addToDomainWhitelist(domain: string) {
    if (!whitelist.includes(domain)) {
      whitelist.unshift(domain);
    }
  }

  return {
    addToDomainWhitelist,
    options: () => ({
      ...options,
      allowedDomains: whitelist,
    }),
  };
}

export function tokenGetter() {
  const token = '';
  return token;
}

export const jwtOptions = jwtOptionsFactory({
  // TODPO
  tokenGetter: tokenGetter,
  allowedDomains: [environment.apiDomain, new RegExp('^null$')],
  // TODO
  // disallowedRoutes: ["http://example.com/examplebadroute/"],
  // headerName: 'authentication',
  // authScheme: 'Bearer ',
  throwNoTokenError: false,
  skipWhenExpired: false,
});

export function scrollToTop() {
  setTimeout(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, 200);
}

export function reloadCurrentPage(url: string) {
  window.location.href = window.location.protocol + '//' + window.location.host + url;
}

export function roundUp(value: number, decimalPlaces: number): number {
  const factor = Math.pow(10, decimalPlaces);
  return Math.ceil(value * factor) / factor;
}
